/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Initiate settlement request
 */
export interface InitiateWithdrawRequest {
  /**
   * Settlement destination ID
   */
  destinationId: number;
  /**
   * Transfer quantity. Use asset.qtyScale.
   */
  quantity: number;
  /**
   * Transfers quantity can be reduced to this level. Use asset.qtyScale.
   */
  allowReduceQuantityTo?: number;
  /**
   * Note for admins
   */
  noteForAdmin?: string;
  /**
   * Note for client
   */
  noteForClient?: string;
}
